import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledHeroSection = styled.section`
  min-height: 88vh;
  display: flex;
  align-items: center;

  .inner {
    width: 100%;
    max-width: 1260px;
    margin: 0 auto;
    padding: 0 clamp(28px, 6vw, 80px);
  }

  .eyebrow {
    margin: 0 0 24px;
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: 12px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
  }

  .headline {
    margin: 0;
    max-width: 980px;
    color: var(--text-primary);
    font-size: clamp(54px, 8vw, 108px);
    line-height: 0.95;
    letter-spacing: -0.06em;
    font-weight: 600;
  }

  .headline .accent {
    color: var(--sydneyblue);
  }

  .subheadline {
    margin: 28px 0 0;
    max-width: 700px;
    color: var(--text-secondary);
    font-size: clamp(18px, 2vw, 23px);
    line-height: 1.75;
  }

  .subheadline strong {
    color: var(--text-primary);
    font-weight: 600;
  }

  .ctaRow {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 36px;
  }

  .primaryBtn,
  .secondaryBtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    padding: 0 22px;
    border-radius: 999px;
    text-decoration: none;
    font-size: 13px;
    font-family: var(--font-mono);
    transition: var(--transition);
  }

  .primaryBtn {
    color: #fff;
    background: #111;
    border: 1px solid #111;
  }

  .secondaryBtn {
    color: var(--text-primary);
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid var(--border-light);
  }

  .primaryBtn:hover,
  .secondaryBtn:hover {
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    min-height: auto;
    padding: calc(var(--nav-height) + 28px) 0 90px;
  }
`;

const Hero = () => (
  <StyledHeroSection>
    <div className="inner">
      <p className="eyebrow">Software • Data • ML • AI</p>

      <h1 className="headline">
        Building <span className="accent">useful systems</span> from messy real-world data.
      </h1>

      <p className="subheadline">
        I’m <strong>Hemang Sharma</strong>. I build across{" "}
        <strong>analytics, software, data pipelines, machine learning, and AI</strong>.
      </p>

      <div className="ctaRow">
        <Link className="primaryBtn" to="/projects">
          Explore Work
        </Link>
        <Link className="secondaryBtn" to="/experience">
          Experience
        </Link>
      </div>
    </div>
  </StyledHeroSection>
);

export default Hero;